import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Styles from "../homework/assets/Form.module.css";
import { Button, Input, Label } from "reactstrap";
import axiosInstance from "../../axiosInterceptor";

import grp663 from "../homework/assets/images/Group 663.png";
import grp713 from "../homework/assets/images/Group 713.png";
import vector132 from "../homework/assets/images/Vector 132.png";
import pluscircle from "../homework/assets/images/plus circle_.png";
import iconaction from "../homework/assets/images/icon _action cancel circle close delete exit remove button x icon_.png";
import { toast } from "react-toastify";
import CommonEditor from "../masters/CommonEditor";

const Searchengine = () => {
  const location = useLocation();
  const editData = location.state;
  const navigator = useNavigate();

  const [question, setQuestion] = useState(editData?.question || "");
  const [answer, setAnswer] = useState(editData?.answer || "");
  const [showQuestion, setShowQuestion] = useState(true);
  const [showAnswer, setShowAnswer] = useState(true);
  // const [selectedQuestionOption, setSelectedQuestionOption] = useState(null);
  // const [selectedAnswerOption, setSelectedAnswerOption] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(
    editData?.subjectId?._id || "",
  );
  const [questionTypes, setQuestionTypes] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState(
    editData?.subCategoryId?._id || "",
  );
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isQuestionEditMode, setIsQuestionEditMode] = useState(false);
  const [isAnswerEditMode, setIsAnswerEditMode] = useState(false);

  const [subSubjects, setSubSubjects] = useState([]);
  const [selectedSubSubject, setSelectedSubSubject] = useState(
    editData?.subSubjectId?._id || "",
  );
  const [filteredSubSubjects, setFilteredSubSubjects] = useState([]);

  const [selectedValue, setSelectedValue] = useState("");

  // useEffect(() => {
  //   const fetchSubjects = async () => {
  //     try {
  //       const response = await axiosInstance.get(`admin/subject/getAllSubject`);
  //       if (response.data.isSuccess) {
  //         setSubjects(response.data.data);
  //       } else {
  //         toast.error(response.data.message);
  //       }
  //     } catch (error) {
  //       toast.error("Something went wrong. Please try again!!");
  //     }
  //   };

  //   fetchSubjects();
  // }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axiosInstance.get(
          `admin/subSubject/getSubjectWiseSubSubject`,
        );
        if (response.data.isSuccess) {
          setSubjects(response.data.data);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again!!");
      }
    };

    fetchSubjects();
  }, []);

  // Update filtered subSubjects whenever selectedSubject changes
  useEffect(() => {
    if (selectedSubject) {
      const selectedMainSubject = subjects.find(
        (subject) => subject?.mainSubjectId === selectedSubject,
      );
      setFilteredSubSubjects(
        selectedMainSubject ? selectedMainSubject?.subSubject : [],
      );
    } else {
      setFilteredSubSubjects([]);
    }
  }, [selectedSubject, subjects]);

  useEffect(() => {
    const fetchQuestionTypes = async () => {
      try {
        const response = await axiosInstance.get(
          `admin/category/getAllCategory`,
        );
        if (response.data.isSuccess) {
          const categories = response.data.data;
          const homeCategory = categories.find(
            (category) => category.name === "Homework Help",
          );
          if (homeCategory) {
            const categoryId = homeCategory._id;
            await fetchSubcategories(categoryId);
          } else {
            toast.error("No category named 'home' found.");
          }
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again!!");
      }
    };

    const fetchSubcategories = async (categoryId) => {
      try {
        const response = await axiosInstance.get(
          `admin/subcategory/getCategoryWiseSubcategory/${categoryId}`,
        );
        if (response.data.isSuccess) {
          setQuestionTypes(response.data.subCategory);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again!!");
      }
    };

    fetchQuestionTypes();
  }, []);

  const toggleQuestionEditMode = () => {
    setIsQuestionEditMode(!isQuestionEditMode);
  };

  const toggleAnswerEditMode = () => {
    setIsAnswerEditMode(!isAnswerEditMode);
  };

  const handleSubmit = async () => {
    try {
      // setIsSubmitting(true);
      let response;
      if (editData) {
        response = await axiosInstance.put(
          `admin/library/updateQA/${editData._id}`,
          {
            question,
            answer,
            mainSubjectId: selectedSubject,
            subCategoryId: selectedQuestionType,
            subjectId: selectedSubSubject,
            // showQuestion,
            // showAnswer,
          },
        );
      } else {

        if (!editData) {
          if (!question) {
            toast.error("Please enter a question.");
            return;
          }
          if (!selectedSubject) {
            toast.error("Please select a subject.");
            return;
          }
          if (!selectedSubSubject) {
            toast.error("Please select a sub subject.");
            return;
          }
          if (!selectedQuestionType) {
            toast.error("Please select a question type.");
            return;
          }
          if (!answer) {
            toast.error("Please enter an answer.");
            return;
          }

        }

        response = await axiosInstance.post(`admin/library/createQA`, {
          question,
          answer,
          mainSubjectId: selectedSubject,
          subCategoryId: selectedQuestionType,
          subjectId: selectedSubSubject,
          // showQuestion,
          // showAnswer,
        });
      }
      if (response.data.isSuccess) {
        toast.success(response.data.message);
        handleReset();
        navigator("/library-question-list");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    } finally {
      // setIsSubmitting(false);
    }
  };

  const handleAddClick = () => {
    handleSubmit();
  };

  // const handleQuestionOptionClick = (option) => {
  //   if (option === "show") {
  //     setShowQuestion(true);
  //   } else {
  //     setShowQuestion(false);
  //   }
  //   setSelectedQuestionOption(option);
  // };

  // const handleAnswerOptionClick = (option) => {
  //   if (option === "show") {
  //     setShowAnswer(true);
  //   } else {
  //     setShowAnswer(false);
  //   }
  //   setSelectedAnswerOption(option);
  // };

  const handleSubjectChange = (event) => {
    setSelectedSubject(event.target.value);
    setSelectedSubSubject("");
  };

  const handleSubSubjectChange = (e) => {
    setSelectedSubSubject(e.target.value);
  };

  const handleQuestionTypeChange = (event) => {
    setSelectedQuestionType(event.target.value);
  };

  const handleReset = () => {
    setQuestion("");
    setAnswer("");
    setShowQuestion(true);
    setShowAnswer(true);
    // setSelectedQuestionOption(null);
    // setSelectedAnswerOption(null);
    setSelectedSubject("");
    setSelectedQuestionType("");
    setSelectedSubSubject("");
  };

  return (
    <div>
      <div className={`${Styles.second_container}`}>
        <div className="mt-4 mb-4">
          <div className="row">
            <div className="col-sm-6">
              <h4 className="page-title">Q & A - Search-engine </h4>
              <p className="page-subtitle">{editData?._id ? "Edit" : "Add"} Q & A</p>
            </div>
            {/* <div className="col-sm-6 text-end">
              <Link to="/library-question-list">
                <Button>Back</Button>
              </Link>
            </div> */}
          </div>
        </div>
        <div className={`bg-white ${Styles.assignment_content}`}>
          <div>
            <div className="d-flex justify-content-between ">
              <div className="ps-5 pt-5">
                <span className={`${Styles.student_corner_text}`}>
                  Question
                </span>
              </div>
              <div className={`${Styles.button_edit} pe-5`}>
                <Button
                  className={`${Styles.button_edit}`}
                  onClick={toggleQuestionEditMode}
                >
                  {isQuestionEditMode ? (
                    <>
                      <span>Edit</span>
                      <img
                        src={grp713}
                        alt="error"
                        className="ps-2"
                        srcSet=""
                      />
                    </>
                  ) : (
                    "Edit"
                  )}
                </Button>
                <span className={`${Styles.drop_down_arrow}`}>
                  <img src={vector132} alt="error" className="ps-2" srcSet="" />
                </span>
              </div>
            </div>
            <form className="ps-5 pe-5 pt-3">
              <div className="form-group row mb-4">
                <div className="col-sm-12">
                  <CommonEditor
                    value={question}
                    placeholder="Enter content ..."
                    onChange={setQuestion}
                    readOnly={editData && !isQuestionEditMode}
                    className={`${Styles.h_200}`}
                  />
                </div>
              </div>

              <div className="form-group row mb-4 mt-5 pt-3">
                <Label for="inputSubject" className="col-sm-2 col-form-label">
                  Subject<b className="ms-2">:</b>
                </Label>
                <div className="col-sm-6">
                  <Input
                    id="inputSubject"
                    name="select"
                    type="select"
                    onChange={handleSubjectChange}
                    value={selectedSubject}
                  >
                    <option value="">--- Please select subject ---</option>
                    {subjects.map((subject) => (
                      <option
                        key={subject?.mainSubjectId}
                        value={subject?.mainSubjectId}
                      >
                        {subject?.mainSubject}
                      </option>
                    ))}
                  </Input>
                </div>
              </div>

              <div className="form-group row mb-4 pt-3">
                <Label
                  for="inputSubSubject"
                  className="col-sm-2 col-form-label"
                >
                  Sub Subject<b className="ms-2">:</b>
                </Label>
                <div className="col-sm-6">
                  <Input
                    id="inputSubSubject"
                    name="select"
                    type="select"
                    onChange={handleSubSubjectChange}
                    value={selectedSubSubject}
                  >
                    <option value="">--- Please select sub subject ---</option>
                    {filteredSubSubjects.map((sub) => (
                      <option key={sub?._id} value={sub?._id}>
                        {sub?.subSubjectName}
                      </option>
                    ))}
                  </Input>
                </div>
              </div>

              <div className="form-group row mb-4">
                <Label for="inputPassword" className="col-sm-2 col-form-label">
                  Question Type<b className="ms-2">:</b>
                </Label>
                <div className="col-sm-6">
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    onChange={handleQuestionTypeChange}
                    value={selectedQuestionType}
                    disabled={editData && !isQuestionEditMode}
                  >
                    <option value="">
                      {editData
                        ? editData?.subCategoryId
                          ? editData?.subCategoryId.name
                          : "--- Please select question type ---"
                        : "--- Please select question type ---"}
                    </option>
                    {questionTypes?.map((questionType) => (
                      <option key={questionType._id} value={questionType._id}>
                        {questionType.name}
                      </option>
                    ))}
                  </Input>
                </div>
              </div>
            </form>
            {/* <div
              className={`d-flex justify-content-around ${Styles.quesion_color} p-3`}
            >
              <div className="d-flex">
                <div
                  className={`d-flex justify-content-around align-items-center ${Styles.question_right
                    } me-4 ${selectedQuestionOption === "dontShow"
                      ? Styles.selectedOption
                      : ""
                    }`}
                  onClick={() => handleQuestionOptionClick("dontShow")}
                >
                  <p className="pt-3">Don’t Show Question</p>
                  <img src={iconaction} alt="" />
                </div>
                <div
                  className={`d-flex justify-content-around align-items-center ${Styles.question_right
                    } ${selectedQuestionOption === "show"
                      ? Styles.selectedOption
                      : ""
                    }`}
                  onClick={() => handleQuestionOptionClick("show")}
                >
                  <p className="pt-3">Show Question</p>
                  <img src={grp663} alt="" />
                </div>
              </div>
            </div> */}
            <div className="d-flex justify-content-between mt-4">
              <div className="ps-5 pt-2">
                <span className={`${Styles.student_corner_text}`}>Answer</span>
              </div>
              <div className={`${Styles.button_edit} pe-5`}>
                <Button
                  className={`${Styles.button_edit}`}
                  onClick={toggleAnswerEditMode}
                >
                  {isAnswerEditMode ? (
                    <>
                      <span>Edit</span>
                      <img
                        src={grp713}
                        alt="error"
                        className="ps-2"
                        srcSet=""
                      />
                    </>
                  ) : (
                    "Edit"
                  )}
                </Button>
                <span className={`${Styles.drop_down_arrow}`}>
                  <img src={vector132} alt="error" className="ps-2" srcSet="" />
                </span>
              </div>
            </div>
            <form className="ps-5 pe-5 pt-3">
              <div className="form-group row mb-4">
                <div className="col-sm-12">
                  <CommonEditor
                    value={answer}
                    placeholder="Enter content ..."
                    onChange={setAnswer}
                    readOnly={editData && !isAnswerEditMode}
                    className={`${Styles.h_200}`}
                  />
                </div>
              </div>
            </form>
            <br />
            <br />
            {/* <div
              className={`d-flex justify-content-around ${Styles.quesion_color} p-3`}
            >
              <div className="d-flex">
                <div
                  className={`d-flex justify-content-around align-items-center ${Styles.question_right
                    } me-4 ${selectedAnswerOption === "dontShow"
                      ? Styles.selectedOption
                      : ""
                    }`}
                  onClick={() => handleAnswerOptionClick("dontShow")}
                >
                  <p className="pt-3">Don’t Show Answer</p>
                  <img src={iconaction} alt="" />
                </div>
                <div
                  className={`d-flex justify-content-around align-items-center ${Styles.question_right
                    } ${selectedAnswerOption === "show" ? Styles.selectedOption : ""
                    }`}
                  onClick={() => handleAnswerOptionClick("show")}
                >
                  <p className="pt-3">Show Answer</p>
                  <img src={grp663} alt="" />
                </div>
              </div>
            </div> */}


            {/* <div className="mb-4 text-center mt-4">
              <Button
                className="action-button add-from-new"
                onClick={handleAddClick}
              >
                <img src={pluscircle} alt="plus" width={30} />
                <span className="mx-2"> Add</span>
              </Button>
            </div> */}

            {/* Button Section */}
            <div className="form-group row mb-4">
              <Label
                for="inputPassword"
                className="col-sm-4 col-form-label"
              >
                <b className="ms-2"></b>
              </Label>
              <div className="col-sm-7 d-flex">
                <div className={`${Styles.submit_button}`}>
                  <Button
                    type="submit"
                    onClick={handleAddClick}
                  >
                    {editData?._id ? "Update" : "Save"}
                  </Button>
                </div>
                <div className={`${Styles.cancel_button} me-4 mx-2`}>
                  <Link to="/library-question-list">
                    <Button className={`${Styles.cancel_button}`}>
                      Cancel
                    </Button>
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Searchengine;
